<template>
  <v-dialog
    v-model="internalModelValue"
    width="550px"
    :fullscreen="isMobile"
    persistent
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>{{
            $t('settings.features.valuation.confirmation-title')
          }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="close"
            />
          </v-toolbar-items>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="mt-4 text-body-1">
        <div class="pb-4">{{ $t('settings.features.valuation.confirmation.body-texts.0') }}</div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="grey-darken-3"
          variant="text"
          @click="close"
        >
          {{ $t('settings.features.valuation.confirmation-close-btn-label') }}
        </v-btn>

        <v-spacer />

        <v-btn
          color="success"
          variant="text"
          @click="confirm"
        >
          {{ $t('settings.features.valuation.confirmation-btn-label') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useDisplay } from 'vuetify'

type Props = {
  modelValue: boolean
  confirmationDialogSetting: String
}
const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'update-confirmed'): void
  (e: 'update-canceled'): void
}>()

const internalModelValue = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value),
})

const close = () => {
  emit('update:modelValue', false)
  emit('update-canceled')
}
const confirm = () => {
  emit('update-confirmed')
}

const { smAndDown: isMobile } = useDisplay()
</script>
